<template>
  <div class="machine-user">
    <search-upgrade
      v-on:oneUpgrade="oneUpgrade"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      :machineGroup="machineGroup"
      :selectList="selectList"
      :search="search"
    >
    </search-upgrade>
    <upgrade-version
      v-on:cancel="cancel"
      v-on:refreshContent="refreshContent"
      :MachineNo="localMachineNo"
      :upgradeType="upgradeType"
      :isOneUpdate="isOneUpdate"
      :dialogUpgrade="dialogUpgrade"
      :rowInfo="nowRowInfo"
      :isOneKey="isOneKey"
    >
    </upgrade-version>
    <div class="table vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        :data="userMachineList"
        style="width: 100%"
        max-height="638"
        :border="true"
      >
        <el-table-column type="selection" :selectable="selectable" width="40" :align="'center'"></el-table-column>
        <el-table-column
          prop="userName"
          :show-overflow-tooltip="true"
          :label="$t('machineUser.userName')"
          width="160"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="equipmentNo"
          :label="$t('machineUser.equipmentNo')"
          width="160"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          width="180"
          prop="equipmentName"
          :label="$t('machineUser.name')"
          :show-overflow-tooltip="true"
          :align="'center'"
        ></el-table-column>
        <el-table-column width="180" prop="teamName" :label="$t('upgrade.teamId')" :align="'center'">
          <template #default="scope">
            {{ scope.row.userEquipmentTeam && scope.row.userEquipmentTeam.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="vmcName"
          :show-overflow-tooltip="true"
          width="180"
          :label="$t('upgrade.Manage.740646-0')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="vmcVersion"
          :show-overflow-tooltip="true"
          width="180"
          :label="$t('upgrade.Manage.740646-1')"
          :align="'center'"
        ></el-table-column>
        <el-table-column width="100" prop="versionState" :label="$t('upgrade.vmcApply')" :align="'center'">
          <template #default="scope">
            <el-tag type="success" v-if="scope.row.versionState == 1">{{ $t("machineUser.yes") }}</el-tag>
            <el-tag type="danger" v-else>{{ $t("machineUser.no") }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="apkName"
          :show-overflow-tooltip="true"
          width="250"
          :label="$t('upgrade.localApp')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="apkVersion"
          :show-overflow-tooltip="true"
          :label="$t('upgrade.localAppVersion')"
          :align="'center'"
          width="250"
        ></el-table-column>
        <el-table-column
          fixed="right"
          :label="$t('common.operate')"
          :width="$i18n.locale == 'zh_CN' ? 196 : 250"
          :align="'center'"
        >
          <template slot-scope="scope">
            <!-- <el-progress :text-inside="true" :stroke-width="26" :percentage="70"></el-progress> -->
            <template v-if="scope.row.apkState == 1 || scope.row.vmcState == 1">
              <div v-if="scope.row.apkState == 1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">APK{{ $t("upgrade.sjzhong") }}</span>
                <span class="el-icon-loading"></span>
              </div>
              <div v-if="scope.row.vmcState == 1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">VMC{{ $t("upgrade.sjzhong") }}</span>
                <span class="el-icon-loading"></span>
              </div>
            </template>
            <template v-else-if="scope.row.apkState == 2 || scope.row.vmcState == 2">
              <div v-if="scope.row.apkState == 2" style="color: green; font-size: 13px">
                <span>APK{{ $t("upgrade.sjcg") }}</span>
              </div>
              <div v-if="scope.row.vmcState == 2" style="color: red">
                <span>VMC{{ $t("upgrade.sjcg") }}</span>
              </div>
            </template>
            <template v-else-if="scope.row.apkState == -1 || scope.row.vmcState == -1">
              <div v-if="scope.row.apkState == -1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">APK{{ $t("upgrade.sjsb") }}</span>
              </div>
              <div v-if="scope.row.vmcState == -1" style="color: red">
                <span style="font-size: 13px; margin-right: 3px">VMC{{ $t("upgrade.sjsb") }}</span>
              </div>
            </template>
            <template v-else>
              <el-button
                type="primary"
                icon="el-icon-upload"
                size="mini"
                v-hasPerm="['upgrade:version:apk']"
                @click="handleUpgradeApk(scope.row)"
                style="padding: 7px"
                >{{ $t("upgrade.upgradeApk") }}</el-button
              >
              <el-button
                type="warning"
                icon="el-icon-upload"
                size="mini"
                v-hasPerm="['upgrade:version:vmc']"
                @click="handleUpgradeFirmware(scope.row)"
                style="padding: 7px"
                >{{ $t("upgrade.upgradeFirmware") }}</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="(page.pageIndex == 1 && userMachineList.length > 1) || page.pageIndex != 1"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        :page-size="page.pageSize"
        @current-change="currentChange"
        @size-change="sizeChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import SearchUpgrade from "_c/upgrade/SearchUpgrade.vue";
  import UpgradeVersion from "_c/upgrade/UpgradeVersion.vue";
  let timeoutIds = [];
  export default {
    name: "Manage",
    components: {
      UpgradeVersion,
      SearchUpgrade
    },
    data() {
      return {
        loading: false,
        machineGroup: [],
        userMachineList: [],
        page: {
          pageSize: 10,
          pageIndex: 1,
          totalSize: 0
        },
        search: {
          userName: "",
          equipmentNo: "",
          equipmentName: "",
          teamId: "",
          vmcName: "",
          apkVersion: ""
        },
        dialogUpgrade: false,
        localMachineNo: "",
        upgradeType: "",
        selectList: [],
        isOneUpdate: 0,
        nowRowInfo: {},
        path: "",
        isOneKey: false
      };
    },
    mounted() {
      this.path = this.$route.path;
      this.listMachineGroup();
      this.currentChange();
    },
    beforeMount() {
      this.clearTimer();
    },
    destroyed() {
      this.clearTimer();
    },
    methods: {
      handleSelectionChange(val) {
        this.selectList = val;
      },
      refreshContent(type) {
        this.upgradeType = parseInt(type);
      },
      cancel(dialog, state) {
        this.dialogUpgrade = dialog;
        this.isOneUpdate = 0;
        if (state) {
          this.currentChange(this.page.pageIndex);
        }
      },
      // 开始暂停
      handlePlayPause(row, boolean) {
        console.log(row, boolean);
      },
      // 删除按钮
      handleDelete(row) {
        console.log(row);
      },
      // 获取设备分组
      listMachineGroup() {
        this.$api.request(this.$url.UserMachineGroup.list, this.$method.get).then(res => {
          if (res.code === 0) {
            this.machineGroup = res.data;
          }
        });
      },
      // 一键升级按钮
      oneUpgrade() {
        let _self = this;
        let selectList = this.selectList;
        let machineNoStr = "";
        selectList.forEach(item => {
          console.log(item);

          machineNoStr += item.id + ",";
        });
        machineNoStr = machineNoStr.slice(0, machineNoStr.length - 1);
        _self.localMachineNo = machineNoStr;
        _self.dialogUpgrade = true;
        _self.upgradeType = 1;
        _self.isOneUpdate = 1;
        _self.isOneKey = true;
      },
      // 升级APK
      handleUpgradeApk(row) {
        let _self = this;
        _self.localMachineNo = row.equipmentNo;
        _self.dialogUpgrade = true;
        _self.upgradeType = 1;
        _self.isOneKey = false;
      },
      // 升级VMC
      handleUpgradeFirmware(row) {
        let _self = this;
        _self.localMachineNo = row.equipmentNo;
        _self.dialogUpgrade = true;
        _self.upgradeType = 2;
        _self.nowRowInfo = row;
      },
      // 提交搜索按钮
      onSubmit(data) {
        this.search = data;
        this.currentChange();
      },
      // 提交重置按钮
      resetSearch(data) {
        this.search = data;
        this.currentChange();
      },
      sizeChange(size) {
        this.page.pageSize = size;
        this.currentChange();
      },
      // 加载列表内容
      currentChange(pageIndex) {
        let _self = this;
        this.clearTimer();
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.UserMachine.upPage, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              let listset = res.data.records;
              for (let i = 0; i < listset.length; i++) {
                if (parseInt(listset[i]["apkState"]) == 1 || parseInt(listset[i]["vmcState"]) == 1) {
                  let biaoshi = "apkState";
                  if (parseInt(listset[i]["apkState"]) == 1) {
                    biaoshi = "apkState";
                  } else if (parseInt(listset[i]["vmcState"]) == 1) {
                    biaoshi = "vmcState";
                  }
                  _self.djsChange(listset[i]["equipmentNo"], biaoshi);
                }
              }
              this.userMachineList = listset;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      djsChange(equipmentNo, biaoshi) {
        let that = this;
        let url = this.$url.Upgrade.appStatus;
        if (biaoshi == "apkState") {
          url = this.$url.Upgrade.appStatus;
        } else if (biaoshi == "vmcState") {
          url = this.$url.Upgrade.firmwareStatus;
        }

        this.$api
          .request(url, this.$method.get, { equipmentNo: equipmentNo })
          .then(res => {
            if (res.code == 0) {
              if (res.data) {
                const index = this.userMachineList.findIndex(item => item.equipmentNo === equipmentNo);
                if (index !== -1) {
                  this.userMachineList[index][biaoshi] = res.data;
                }
                if (res.data == 1 && this.path == this.$route.path) {
                  //升级中继续轮询请求
                  // setTimeout(() => {
                  //   let timer = that.djsChange(equipmentNo, biaoshi);
                  //   timeoutIds.push(timer);
                  // }, 5000);
                }
              }
            }
          })
          .catch(() => {
            if (that.path == that.$route.path) {
              // setTimeout(() => {
              //   let timer = that.djsChange(equipmentNo, biaoshi);
              //   timeoutIds.push(timer);
              // }, 5000);
            }
          });
      },
      //清除定时器
      clearTimer() {
        for (let i in timeoutIds) {
          clearTimeout(timeoutIds[i]);
        }
        timeoutIds = [];
      }
    }
  };
</script>

<style lang="scss">
  .table {
    overflow: hidden;
  }
  .table .el-table .warning-row {
    background: #f56c6c;
    color: #ffffff;
  }
  .table .el-table .hover-row {
    color: #606266;
  }
  .machine-user .image {
    position: absolute;
  }
  .machine-user .maturity {
    color: #f56c6c;
  }
  .machine-user .renew {
    color: #67c23a;
  }
</style>
